import { useNavigate } from 'react-router-dom'

import { Box, Callout, Title } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { AccountsPageDocument } from 'generated/resources/graphql'

import { useEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { useActiveMarkets } from 'modules/benefits/hooks/useActiveMarkets'
import { events } from 'modules/benefits/lib/events'
import { BenefitsBankAccountCardList } from 'modules/benefits/pages/BenefitsHomePage/BenefitsBankAccountCardList'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const AccountsPage = () => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  useEffect(() => {
    track(trackingEvents.benefits.openBenefitsAccountsPage)
  }, [])

  const { activeMarkets, loading } = useActiveMarkets()

  // Query to check if user can edit cycle date
  const { data } = useQuery(AccountsPageDocument)

  const canChangeCycleDay = data?.benefits?._policies?.canChangeCycleDay?.can ?? false

  const handleConfigureClick = () => {
    track(events.clickConfigureCycleDateFromAccountsPage)
    navigate(navigation.settings.benefits.fullPath())
  }

  return (
    <ResponsivePage.Body variant="full">
      <Box gap="s32">
        {canChangeCycleDay && (
          <Callout type="info" compact>
            <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center">
              {i18n.t('benefits.homepage.bank_account.callout.configure_cycle.description')}
              <F0Button
                variant="outline"
                size="md"
                label={i18n.t('benefits.homepage.bank_account.callout.configure_cycle.button')}
                onClick={handleConfigureClick}
              />
            </Box>
          </Callout>
        )}
        <Title
          variant="400"
          title={i18n.t('benefits.homepage.bank_account.title')}
          description={i18n.t('benefits.homepage.bank_account.description_legal_entities')}
        />

        <BenefitsBankAccountCardList activeMarkets={activeMarkets} loading={loading} />
      </Box>
    </ResponsivePage.Body>
  )
}

export default AccountsPage
